
import React from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { Button } from "@/components/ui/button"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, actionSecondary, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {(action || actionSecondary) && (
              <div className="mt-2 flex flex-wrap gap-2">
                {action && (
                  React.isValidElement(action) ? (
                    action
                  ) : (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={action.onClick}
                      className={action.className}
                    >
                      {action.label}
                    </Button>
                  )
                )}
                {actionSecondary && (
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={actionSecondary.onClick}
                    className={actionSecondary.className}
                  >
                    {actionSecondary.label}
                  </Button>
                )}
              </div>
            )}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}

